import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const SettingsModal = ({ show, onHide }) => {
    const { token } = useAuth();
    const [settings, setSettings] = useState({
        allow_staff_withdrawal: false,
        auto_reset_balance: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show && token) {
            fetchSettings();
        }
    }, [show, token]);

    const fetchSettings = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await fetch('/api/permissions/settings', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setSettings(prev => ({ ...prev, ...data }));
            } else {
                setError('Sozlamalarni yuklashda xatolik');
            }
        } catch (e) {
            console.error(e);
            setError('Server bilan bog\'lanishda xatolik');
        } finally {
            setLoading(false);
        }
    };

    const toggleSetting = async (key) => {
        const newValue = !settings[key];
        // Optimistic update
        setSettings(prev => ({ ...prev, [key]: newValue }));

        try {
            const res = await fetch('/api/permissions/settings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ key, value: newValue })
            });

            if (!res.ok) {
                // Revert on failure
                setSettings(prev => ({ ...prev, [key]: !newValue }));
                setError('Sozlamani o\'zgartirishda xatolik');
            }
        } catch (e) {
            console.error(e);
            // Revert on failure
            setSettings(prev => ({ ...prev, [key]: !newValue }));
            setError('Server bilan bog\'lanishda xatolik');
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title><i className="bi bi-gear me-2"></i>Sozlamalar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                {loading && <div className="text-center py-3"><div className="spinner-border text-primary"></div></div>}

                {!loading && (
                    <div className="d-flex flex-column gap-3">
                        <Form.Check
                            type="switch"
                            id="allow_staff_withdrawal"
                            label="Xodimlarga chiqim qilishga ruxsat berish"
                            checked={settings.allow_staff_withdrawal}
                            onChange={() => toggleSetting('allow_staff_withdrawal')}
                            className="fs-5"
                        />
                        <Form.Text className="text-muted d-block mt-0 mb-3">
                            Agar yoqilsa, xodimlar ham kassadan pul chiqarishlari mumkin bo'ladi.
                        </Form.Text>

                        <Form.Check
                            type="switch"
                            id="auto_reset_balance"
                            label="Balansni avtomatik nollash (har kuni 00:00 da)"
                            checked={settings.auto_reset_balance}
                            onChange={() => toggleSetting('auto_reset_balance')}
                            className="fs-5"
                        />
                        <Form.Text className="text-muted d-block mt-0">
                            Agar yoqilsa, tizim har kuni yarim tunda barcha balanslarni nollashtiradi (avtomatik chiqim qiladi).
                        </Form.Text>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Yopish</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SettingsModal;
